import { FormControl, Grid, MenuItem, Select } from '@mui/material';
import React from 'react';
import { usePRGraphDetails } from '../../data/DataProviders/PhaseResolvedDataProvider';
import { isDataLoaded } from '../../types';
import { DataIndicators } from '../DataIndicators';
import { PhaseResolvedGraphData } from './PhaseResolvedGraphData';
import { phaseConnection } from '../../constants/index';
export const PhaseResolvedGraph: React.FC<{
    channelNumber: number;
    graphDate: string;
    filterChecked?: boolean;
    pdConversion?: string;
    scaleValue: number;   
}> = (props) => { 
    const responsePRData = usePRGraphDetails();
    const isEmpty = isDataLoaded(responsePRData.responsePRData)
        ? responsePRData.responsePRData.value.chartData.length === 0
        : false;

    const [phaseConnectionValue, setPhaseConnectionValue] = React.useState('');
    React.useEffect(() => {
        responsePRData.fetchPRData(
            props.channelNumber,
            props.graphDate,
            props.filterChecked,
            props.pdConversion,
            phaseConnectionValue
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.graphDate, props.filterChecked, props.pdConversion]);

    const getPhaseConnect = (e: string, channelNumberIdentifier: any): void => {
        setPhaseConnectionValue(e);
        responsePRData.fetchPRData(
            channelNumberIdentifier,
            props.graphDate,
            props.filterChecked,
            props.pdConversion,
            e
        );
    };
   
    return (
        <>
            {isDataLoaded(responsePRData.responsePRData) && (                
                    <Grid container style={{ borderBottom: '1px solid gray', marginBottom: '15px' }}>
                        <Grid item xs={6}  data-testid="channel-name" style={{ marginTop: '5px', padding: '2px 5px', color: 'rgb(0, 123, 193)' }}>
                            {responsePRData.responsePRData.value.channelName}
                        </Grid>
                        <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 'auto' }} style={{margin:0}}>
                            <Select
                                disabled={false}
                                labelId="demo-select-small"
                                data-testid="phase-selection"
                                id="demo-select-small"
                                value={responsePRData.responsePRData.value.phaseConnection}
                                label="Phase Connection"
                                onChange={(e): void => {
                                    getPhaseConnect(e.target.value as string, props.channelNumber);
                                }}
                            >
                                {phaseConnection.map((element: any, index) => (
                                    <MenuItem key={index} value={element.id}>
                                        {element.value}
                                    </MenuItem>
                                ))}
                            </Select>
                            </FormControl>
                        </Grid>
                    </Grid>              
            )}
            <DataIndicators
                errorMessage="Data found to be 0"
                emptyMessage="Data found to be 0"
                data={responsePRData.responsePRData}
                emptyIcon="BarChart"
                isEmpty={isEmpty}
                isDetailedInfo={false}
                style={{ height: '30vh' }}
            />
            {isDataLoaded(responsePRData.responsePRData) && (
                <>
                    {responsePRData.responsePRData.value.chartData.length > 0 && (
                        <PhaseResolvedGraphData scaleValue={props.scaleValue} value={responsePRData.responsePRData} pdConversions={props.pdConversion}/>
                    )}            
                  </>
            )}
        </>
    );
};